import './drawer_divider_styles.scss';

const DrawerDivider = ({tailWindClasses}) => <div className={`mx-6 ${tailWindClasses !== null && tailWindClasses} drawer-divider`} />

export default DrawerDivider;